import * as React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Breadcrumb } from "~/components/Breadcrumps";
import { useAbility } from "~/lib/ability";
import { AppAdsAbility } from "~/modules/AppAds/ability";
import { SelectedPublisherProvider } from "~/modules/AppAds/components/SelectedPublisherContext";
import { appAdsLinks } from "~/modules/AppAds/links";
import { AdminAppAdsView } from "~/modules/AppAds/views/AdminAppAdsView";
import { SellerAppAdsView } from "~/modules/AppAds/views/SellerAppAdsView";
import { DownloadHistoryView } from "~/modules/AppAds/views/DownloadHistoryView";
import { MissingLinesView } from "~/modules/AppAds/views/MissingLinesView";
import { MismatchedLinesView } from "~/modules/AppAds/views/MismatchedLinesView";

export const AppAdsRoute = () => {
  const abilities = useAbility(AppAdsAbility);

  return (
      <Breadcrumb
        breadcrumb={{
          title: "App-ads.txt",
          to: appAdsLinks.main(),
        }}
      >
        <SelectedPublisherProvider>
          <Routes>
              {abilities.canViewMissingLines() && <Route path="missing-lines" element={<MissingLinesView/>}/>}
              {abilities.canViewMismatchedLines() && <Route path="mismatched-lines" element={<MismatchedLinesView/>}/>}
              {abilities.canViewSellerAppAds() && <Route path="file/*" element={<SellerAppAdsView/>}/>}
              {abilities.canViewAppAds() && <Route path="file/*" element={<AdminAppAdsView/>}/>}
              {abilities.canViewDownloadHistory() && <Route path="download-history" element={<DownloadHistoryView/>}/>}
              <Route path="*" element={<Navigate to={appAdsLinks.appAds()} replace />}/>
          </Routes>
        </SelectedPublisherProvider>
      </Breadcrumb>
  );
};
